module.exports = __webpack_public_path__ + "img/antes_despues_92.cef73d18.png";